import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";


const Chapter5 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);
    
    return (
        <>

             {/* Chapter 5 */}
                <section id="section5" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter5Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter5Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph3}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph4}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph5}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph6}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph7}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph8}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter5Paragraph9}
                    </p>
                </section>
        </>
    )

}

export default Chapter5;
